module.exports = __webpack_public_path__ + "static/media/instructivom5.8ab9f9d5.png";